import { PackImage } from 'apollo/types';
import {
  LocalizedEntranceTicketType,
  LocalizedPack,
  TranslationLanguage,
} from 'apollo/localizedTypes';
import * as texts from 'assets/texts/localizedText';

const columns = (
  statusColumnRender: (value: boolean, record: unknown) => JSX.Element,
  renderTags: (tags: LocalizedEntranceTicketType[]) => JSX.Element,
  editButton: (EditItem: LocalizedPack) => JSX.Element,
  imageGroup: (item: PackImage[] | undefined) => JSX.Element,
  visibilityColumnRender: (value: boolean, record: unknown) => JSX.Element,
  renderTranslationsColumn: (missingTranslations: TranslationLanguage[]) => JSX.Element
) => {
  return [
    {
      title: 'Tipo de ticket',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: texts.translations,
      dataIndex: 'missingTranslations',
      key: 'missingTranslations',
      align: 'center' as const,
      render: renderTranslationsColumn,
    },
    {
      title: 'Precio adultos',
      dataIndex: 'adultValue',
      key: 'adultValue',
    },
    {
      title: 'Precio Adulto mayor o Niños < 4 años',
      dataIndex: 'otherValue',
      key: 'otherValue',
    },
    {
      title: 'Actividades',
      dataIndex: 'activities',
      key: 'activities',
      render: renderTags,
    },
    {
      title: 'Entradas',
      dataIndex: 'entranceTicketTypes',
      key: 'entranceTicketTypes',
      render: renderTags,
    },
    {
      title: 'Fotos',
      dataIndex: 'packImages',
      key: 'packImages',
      render: imageGroup,
    },
    {
      title: 'Estado',
      dataIndex: 'status',
      key: 'status',
      render: statusColumnRender,
    },
    {
      title: 'Visibilidad',
      dataIndex: 'visibility',
      key: 'visibility',
      render: visibilityColumnRender,
    },
    {
      title: 'Acciones',
      dataIndex: 'actions',
      key: 'actions',
      render: editButton,
    },
  ];
};

export default columns;
